import React, { ReactElement } from "react";

import clsx from "clsx";

export default function CenterContainer({ children }: React.PropsWithChildren) {
  return (
    <div className={clsx("flex w-full h-full justify-center pt-48")}>
      {children}
    </div>
  );
}
